<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper is-gather">
      <!-- header start -->
      <header class="header">
        <router-link to="/">
          <a href="#" class="browse">
            <img src="@/assets/img/ico-grid.svg" alt="browse" />
            <span>BROWSE ALL</span>
          </a>
        </router-link>
        <a href="#" class="share" @click="showShareModel = true">
          <span>SHARE PAGE</span>
          <img src="@/assets/img/ico-share.svg" alt="share" />
        </a>
      </header>
      <!-- header end -->

      <!-- main content wrapper start-->
      <main class="content-wrapper">
        <!-- slider start -->
        <section class="slider">
          <slider :height="'400px'" :interval="4500" class="slider-items">
            <slider-item
              class="item"
              v-for="product in productImages"
              :key="product.id"
            >
              <img
                class="center"
                :src="product.product_image"
                alt="poduct image"
              />
            </slider-item>
            <div slot="loading">Loading images ...</div>
          </slider>
          <!-- product info -->
          <div class="product-info has-text-centered">
            <h3 class="title main-title">{{ product.name }}</h3>
            <p>{{ product.description }}</p>
          </div>
        </section>
        <!-- slider end -->

        <!-- product nutrition info start -->
        <section class="product-nutrition">
          <div class="nutrition-field">
            <div class="nutrition-value" style="text-transform: uppercase;">
              {{ product.product_type || "-" }}
            </div>
            <div class="nutrition-title">TYPE</div>
          </div>
          <div class="nutrition-wrapper">
            <div class="nutrition-field">
              <div class="nutrition-value">12.0 - 22.0 % *</div>
              <div class="nutrition-title">THC</div>
            </div>
            <div class="nutrition-field">
              <div class="nutrition-value">0.0 - 1.0 % *</div>
              <div class="nutrition-title">CBD</div>
            </div>
          </div>
          <p class="note">
            <span>*</span> cannabis is a live plant and potency will change
            harvest to harvest.
          </p>
        </section>
        <!-- product nutrition info start -->

        <!-- why to buy section start -->
        <section class="product-benefit p17">
          <h3 class="title section-title">Why to Buy</h3>
          <p>
            Solei gather is suitable for higher energy, social occasions.
            Rediscover the real meaning of a group chat.
          </p>
        </section>
        <!-- why to buy section end -->

        <!-- effects section start -->
        <section class="p17">
          <h3 class="title section-title">EFFECTS</h3>
          <div class="info-list">
            <div class="info-block">
              <div class="info-icon">
                <img
                  src="@/assets/img/ico_effect_high_energy.svg"
                  alt="high energy"
                />
              </div>
              <div class="info-content">High Energy</div>
            </div>
            <div class="info-block">
              <div class="info-icon">
                <img
                  src="@/assets/img/ico_day_night_relax.svg"
                  alt="night relax"
                />
              </div>
              <div class="info-content">Day/Night Relax</div>
            </div>
          </div>
        </section>
        <!-- effects section end -->

        <section class="p17">
          <h3 class="title section-title">Available In</h3>
          <div class="info-list">
            <div class="info-block">
              <div class="info-icon">
                <img src="@/assets/img/ico_dried_flower.svg" alt="mid energy" />
              </div>
              <div class="info-content">Dried Flower</div>
            </div>

            <div class="info-block">
              <div class="info-icon">
                <img src="@/assets/img/ico_pre_rolled.svg" alt="rolled" />
              </div>
              <div class="info-content">Pre-Rolled</div>
            </div>
          </div>
        </section>
        <section class="p17" v-if="productTerpenes.length > 0">
          <h3 class="title section-title">Terpenes</h3>
          <div class="tags">
            <span
              v-for="terpenes in productTerpenes"
              :key="terpenes.id"
              href="#"
              class="tag"
              >{{ terpenes.name }}</span
            >
          </div>
        </section>
      </main>
      <!-- main content wrapper end-->
    </div>
    <!-- share number modal -->
    <div class="modal is-active share-model" v-if="showShareModel">
      <div class="modal-background" @click="closeShareModel"></div>
      <div class="modal-content">
        <div class="modal-title">SHARE</div>
        <div class="modal-content-section">
          <p class="field-title">Enter a phone number to share with</p>
          <form>
            <div class="mobile-field">
              <div class="field">
                <div class="control">
                  <img src="@/assets/img/ico-mobile.png" class="field-icon" />
                  <input class="input" type="text" />
                </div>
              </div>
            </div>
            <div class="keypad">
              <div class="key">1</div>
              <div class="key">2</div>
              <div class="key">3</div>
              <div class="key">4</div>
              <div class="key">5</div>
              <div class="key">6</div>
              <div class="key">7</div>
              <div class="key">8</div>
              <div class="key">9</div>
              <div class="key">0</div>
            </div>
            <div class="form-button">
              <button
                type="button"
                class="button is-white"
                @click="closeShareModel"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="button is-primary"
                @click="closeShareModel"
              >
                SHARE
              </button>
            </div>
          </form>
        </div>
        <!-- Any other Bulma elements you want -->
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeShareModel"
      ></button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import { Slider, SliderItem } from "vue-easy-slider";

export default {
  name: "product",

  data() {
    return {
      showShareModel: false,
      productId: this.$route.params.id
    };
  },

  components: {
    Slider,
    SliderItem
  },

  computed: {
    ...mapGetters({
      product: "Products/selectedProduct",
      productImages: "Products/selectedProductImages",
      productTerpenes: "Products/selectedProductTerpenes"
    })
  },

  methods: {
    ...mapMutations({
      setSelectedProduct: "Products/setSelectedProduct"
    }),

    ...mapActions({
      fetchProduct: "Products/fetchProduct",
      fetchProductImages: "Products/fetchProductImages",
      fetchProductTerpenes: "Products/fetchProductTerpenes"
    }),

    closeShareModel() {
      this.showShareModel = false;
    }
  },

  created() {
    this.fetchProduct(this.productId);
    this.fetchProductImages(this.productId);
    this.fetchProductTerpenes(this.productId);
  },

  destroyed() {
    this.setSelectedProduct({});
  }
};
</script>

<style scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.slider-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.share-model {
  z-index: 10000;
}
</style>
